<template>
    <template v-if="detail.deepLink">
        <div class="row mt-2">
            <div class="col-6">
                <a :href="String(detail.deepLink).replaceAll('https://pay.payqr.kg#', 'https://api.dengi.o.kg/#')" class="button button-icon button-white obank block lg mb-3" target="_blank">OBank</a>
            </div>
            <div class="col-6">
                <a :href="String(detail.deepLink).replaceAll('https://pay.payqr.kg#', 'https://app.mbank.kg/qr/#')" class="button button-icon button-white mbank block lg mb-3" target="_blank">MBank</a>
            </div>
            <div class="col-6">
                <a :href="String(detail.deepLink).replaceAll('https://pay.payqr.kg#', 'https://24.kompanion.kg/qr/#')" class="button button-icon button-white kompanion block lg mb-3" target="_blank">Kompanion</a>
            </div>
            <div class="col-6">
                <a :href="String(detail.deepLink).replaceAll('https://pay.payqr.kg#', 'https://bakai.app/#')" class="button button-icon button-white bakai block lg mb-3" target="_blank">Bakai</a>
            </div>
        </div>
    </template>
    <template v-if="detail.qrCode">
        <div class="dashboard-table-row table-row-v2 mb-3">
            <div class="dashboard-table-column text-wrap text-center">Для проведения платежа, отсканируйте QR-код в приложении банка</div>
        </div>
        <div class="modal-qr-image modal-qr-mkassa mb-3">
            <img :src="detail.qrCode" :alt="detail.description">
        </div>
    </template>
</template>

<script>
export default {
    props: {
        detail: Object
    }
}
</script>